export const formatToUid = (str: string): string => {
  const match = str.match(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/);
  return match ? match.slice(1).join("-") : "";
};
